import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yearPipe',
  standalone: true
})
export class YearPipePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    if (value) {
      const date = new Date(String(value));
      return date;
    }
    return null;
  }

}
